import React, { memo } from 'react';
const bannerImage = '/assets/img/ads-banner.webp';
import Link from 'next/link';
function BannerAds() {
  return (
    <div className="ads-banner-sec">
      <div className="container">
        <div className="ad-banner">
          <Link href="/contact-us">
            <img src={bannerImage} alt="Escort Service" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default memo(BannerAds);
